import React from 'react';
import styled from 'styled-components';
import { colorThemeGenerator, ButtonPrimary, Type } from '@spotify-internal/encore-creator-web';
import {
  black,
  white,
  spacer16,
  spacer20,
  spacer48,
  screenMdMin,
} from '@spotify-internal/encore-foundation';
import { AnchorLogo } from '../../components/Shared/Logos/AnchorLogo';
import { SoundtrapLogo } from '../../components/Shared/Logos/SoundtrapLogo';
import { pageConstraintStyles, PAGE_GUTTER } from './styles';
import { FormattedMessage } from 'react-intl';

export function Products() {
  return (
    <ProductsContainer>
      <ProductsContent>
        <div>
          <ProductHeader>
            <FormattedMessage
              id="landing-page.products.starting-a-podcast"
              defaultMessage="Starting a podcast?"
            />
          </ProductHeader>
          <ProductLogo>
            <AnchorLogo fillColor="#722FD3" />
          </ProductLogo>
          <Type as="p" variant={Type.heading4}>
            <FormattedMessage
              id="landing-page.products.the-easiest"
              defaultMessage="The easiest way to make a podcast. Create and host unlimited episodes, distribute your
            show everywhere, and make money. All for free."
            />
          </Type>
          <ButtonPrimary
            href="https://app.adjust.com/5j335fh?redirect=https%3A%2F%2Fanchor.fm%2Fapp"
            target="_blank"
            rel="noopener noreferrer"
            theme={{
              ...colorThemeGenerator({
                primaryColor: black,
                primaryColorText: white,
                primaryColorFocusText: white,
                primaryColorActiveText: white,
              }),
            }}
            style={{ marginTop: spacer16 }}
          >
            <FormattedMessage
              id="landing-page.products.visit-anchor"
              defaultMessage="Visit Anchor"
            />
          </ButtonPrimary>
        </div>
        <div>
          <ProductHeader>
            <FormattedMessage
              id="landing-page.products.need-an-audio"
              defaultMessage="Need an audio editing suite?"
            />
          </ProductHeader>
          <ProductLogo>
            <SoundtrapLogo fillColor="#722FD3" />
          </ProductLogo>
          <Type as="p" variant={Type.heading4}>
            <FormattedMessage
              id="landing-page.products.record-and-edit"
              defaultMessage="Record and edit your podcast from anywhere with a studio of online creation tools —
            including an interactive transcript feature for fast audio editing."
            />
          </Type>
          <ButtonPrimary
            href="https://www.soundtrap.com/storytellers?utm_source=owned_global_storytellers_engagement&utm_medium=spotify_website_s4p&utm_content=soundtrap_storyteller_button&utm_campaign=spotify_podcasters_global_marketing_creator"
            target="_blank"
            rel="noopener noreferrer"
            theme={{
              ...colorThemeGenerator({
                primaryColor: black,
                primaryColorText: white,
                primaryColorFocusText: white,
                primaryColorActiveText: white,
              }),
            }}
            style={{ marginTop: spacer16 }}
          >
            <FormattedMessage
              id="landing-page.products.visit-soundtrap"
              defaultMessage="Visit Soundtrap"
            />
          </ButtonPrimary>
        </div>
      </ProductsContent>
    </ProductsContainer>
  );
}

const ProductsContainer = styled.div`
  background-color: ${white};
  color: ${black};
`;

const ProductsContent = styled.div`
  ${pageConstraintStyles}

  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${spacer48};
  padding: 54px 16px 80px;

  @media (min-width: ${screenMdMin}) {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 58px;
    padding: 120px ${PAGE_GUTTER};
  }
`;

const ProductHeader = styled(Type).attrs({
  forwardedAs: 'h2',
  variant: Type.heading2,
})`
  padding: 0;
`;

const ProductLogo = styled.div`
  margin: ${spacer20} 0;
  width: 134px;
  height: 33px;
`;
